export default {
    application: {
        create: {
            method: "POST",
            url: "/application/create"
        },
        init: {
            method: "GET",
            url: "/application/init"
        },
        update: {
            method: "PUT",
            url: "/application/update"
        },
        delete: {
            method: "DELETE",
            url: "/application/delete"
        }
    }
}